import Quiz from "../calculator";

let quiz = document.querySelector('.js-calculator');
if (quiz !== null) {
    new Quiz(quiz);
}